import { type FC, memo, useMemo } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import styled from 'styled-components'

import Button from 'components/Button'
import { Body, Heading } from 'components/Text'
import { FlexDivCol, FlexDivRowCentered } from 'components/layout/flex'
import useWindowSize from 'hooks/useWindowSize'
import { ExternalLink } from 'styles/common'
import media from 'styles/media'

type SectionHeadingProps = {
	title: string
	copy?: string
	textLink?: string
	link?: string
	marginTop?: number
}

export const SectionHeading: FC<SectionHeadingProps> = memo(
	({ title, copy, textLink, link, marginTop }) => {
		const { t } = useTranslation()
		const { deviceType } = useWindowSize()
		const isMobile = useMemo(() => deviceType === 'mobile', [deviceType])

		return (
			<TitleContainer $marginTop={marginTop}>
				<FlexDivCol rowGap="5px">
					<StyledHeading variant="h4">{title}</StyledHeading>
					{!isMobile && copy && (
						<Body color="secondary">
							<Trans i18nKey={copy} components={[<Emphasis key="emphasis" href={textLink} />]} />
						</Body>
					)}
				</FlexDivCol>
				{link && (
					<StyledButton
						size="xsmall"
						isRounded
						textTransform="none"
						onClick={() => window.open(link, '_blank')}
					>
						{t('referrals.docs')}
					</StyledButton>
				)}
			</TitleContainer>
		)
	}
)

const Emphasis = styled(ExternalLink)`
	color: ${(props) => props.theme.colors.selectedTheme.newTheme.text.preview};
	cursor: pointer;
`

const TitleContainer = styled(FlexDivRowCentered)<{ $marginTop?: number }>`
	margin: ${(props) => (props.$marginTop !== null ? props.$marginTop : 30)}px 0;
	${media.lessThan('md')`
		margin-top: 0;
	`}
`

const StyledButton = styled(Button)`
	border-width: 0px;
	color: ${(props) => props.theme.colors.selectedTheme.newTheme.text.secondary};
`

const StyledHeading = styled(Heading)`
	font-weight: 400;
`
